var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"project-table-filter",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"pa-0"},[_c('TextInput',{attrs:{"filter-key":"projectName","label":"Project Name","options":_vm.projectNameFilterValues,"type":"textual"}})],1)],1)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }